import React, { useEffect, useRef } from "react";

import { Icon, Thumb, cx } from "../catalogProductStudio/edit/StudioUi";
import { describeVariant, fill } from "./printCenterModel";

/** Checkbox with a real indeterminate ("some selected") state. */
export const TriStateCheckbox = ({ state, onChange, label, disabled, className }) => {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) ref.current.indeterminate = state === "some";
  }, [state]);
  return (
    <input
      ref={ref}
      type="checkbox"
      className={cx("pc-check", className)}
      checked={state === "all"}
      aria-checked={state === "some" ? "mixed" : state === "all"}
      aria-label={label}
      disabled={disabled}
      onChange={onChange}
      onClick={(event) => event.stopPropagation()}
    />
  );
};

/** Why an item cannot produce a sellable label, in plain words. */
export const blockedReasonText = (tt, item) => {
  if (!item) return "";
  if (item.blockedReason === "missing_barcode") return tt("blockedMissingBarcode");
  if (item.blockedReason === "serialized_needs_unit") return tt("blockedSerializedVariant");
  return "";
};

/** Thumbnail + product + colour/size (+ unit barcode for serialized units). */
export const ItemIdentity = ({ tt, item, compact = false, showProduct = true }) => (
  <div className={cx("pc-identity", compact && "is-compact")}>
    <Thumb src={item.imageUrl} size={compact ? 36 : 44} fallbackLabel={item.productTitle} />
    <div className="pc-identity__text">
      {showProduct ? <strong className="pc-identity__title">{item.productTitle}</strong> : null}
      <span className="pc-identity__variant">
        {describeVariant(item) || tt("variantFallback")}
        {item.kind === "unit" ? <span className="pc-unit-tag">{tt("unitTag")}</span> : null}
      </span>
      <code className="pc-identity__barcode">{item.barcode || "—"}</code>
    </div>
  </div>
);

/** Stock on hand, received stock still needing labels, labels held elsewhere. */
export const ItemCounts = ({ tt, item }) => (
  <div className="pc-counts">
    <span className="pc-count" title={tt("onHandHint")}>
      <span className="pc-count__label">{tt("onHandShort")}</span>
      <strong>{item.onHand}</strong>
    </span>
    {item.demand?.outstanding > 0 ? (
      <span className="pc-count is-demand" title={tt("needsLabelsHint")}>
        <span className="pc-count__label">{tt("needsShort")}</span>
        <strong>{item.demand.outstanding}</strong>
      </span>
    ) : null}
    {item.demand?.pending > 0 ? (
      <span
        className="pc-count is-pending"
        title={(item.demand.pendingJobs || [])
          .map((job) => fill(tt("pendingJobHint"), { quantity: job.quantity, name: job.createdByName || "—", job: job.jobId }))
          .join("\n")}
      >
        <Icon name="clock" size={12} />
        <strong>{item.demand.pending}</strong>
      </span>
    ) : null}
  </div>
);
